var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentDeepRoute === 1)?_c('section',[_c(_vm.activeBoardConfiguration?.views.list.component,{key:_vm.$route.path,tag:"component",attrs:{"config":_vm.activeBoardConfiguration,"content-type-label":_vm.contentTypeLabel}})],1):_vm._e(),(_vm.currentDeepRoute === 2)?_c('section',[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }